import { createApi } from "@reduxjs/toolkit/query/react";
import { Ad } from "../../types";
import { AD } from "../../configs";
import { createBaseQuery } from "../helpers/baseQueryHelper";

const adApi = createApi({
  reducerPath: AD.reducerPath,
  baseQuery: createBaseQuery(AD.baseUrl),
  tagTypes: AD.tagTypes,
  endpoints(builder) {
    return {
      fetchAdsByAddress: builder.query<Ad[], string>({
        query: (address: string) => {
          return {
            url: "/address",
            method: "GET",
            params: { q: address },
          };
        },
      }),
    };
  },
});

export const { useFetchAdsByAddressQuery } = adApi;

export { adApi };
